import { bindContributionProvider, createContributionProvider } from "../../../common/contribution-provider";

import { isBindingContextLoaded } from "../../../common/module-guard";

import { DefaultBaseInteractiveRenderContribution } from "./contributions";

import { PathRenderContribution } from "./contributions/constants";

import { DefaultCanvasPathRender } from "./path-render";

import { GraphicRender, PathRender } from "./symbol";

const loadedPathModuleContexts = new WeakSet;

export function bindPathRenderModule({bind: bind}) {
    isBindingContextLoaded(loadedPathModuleContexts, bind) || (bind(DefaultCanvasPathRender).toDynamicValue((({container: container}) => new DefaultCanvasPathRender(createContributionProvider(PathRenderContribution, container)))).inSingletonScope(), 
    bind(PathRender).toService(DefaultCanvasPathRender), bind(GraphicRender).toService(PathRender), 
    bind(PathRenderContribution).toService(DefaultBaseInteractiveRenderContribution), 
    bindContributionProvider(bind, PathRenderContribution));
}

export const pathModule = bindPathRenderModule;
//# sourceMappingURL=path-module.js.map
